module.exports = __webpack_public_path__ + "img/credit cards-group.4ba2c098.svg";